<!-- Backdrop (click-outside area) -->
<div class="scraii-task-mgmt-backdrop" *ngIf="drawerOpen" (click)="closeDrawer()">
</div>

<!-- Side Panel -->
<aside class="scraii-task-mgmt-side-panel" [class.scraii-workflow-open]="drawerOpen" role="dialog" aria-modal="true"
    (click)="$event.stopPropagation()">

    <header class="scraii-workflow-drawer-header my-4 px-3">
        <h2 class="tasks-header-title">Tasks</h2>

        <div class="tasks-header-actions">
            <!-- Sort icon -->
            <mat-icon class="du-mat-icons-event-header" [matTooltip]="sortAsc ? 'Asc' : 'Desc'" svgIcon="notes_sorting"
                (click)="eventSort()">
            </mat-icon>

            <!-- Search wrapper: animated input + icon -->
            <div class="scraii-task-mgmt-search-wrapper">
                <input type="text" placeholder="Search tasks..." class="scraii-task-mgmt-search-input"
                    [class.scraii-task-mgmt-search-input--visible]="showSearchInput" [(ngModel)]="searchText"
                    (keyup)="onSearchTasks()" />

                <!-- Clear icon inside input -->
                <button *ngIf="showSearchInput && searchText" type="button" class="scraii-task-mgmt-search-clear-icon"
                    (click)="clearSearch($event)" aria-label="Clear search">
                    ✕
                </button>

                <button type="button" class="scraii-task-mgmt-side-panel-search-icon" matTooltip="Search"
                    (click)="toggleSearchInput()">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M7.5 3.35616C5.21142 3.35616 3.35616 5.21142 3.35616 7.5C3.35616 9.78858 5.21142 11.6438 7.5 11.6438C9.78858 11.6438 11.6438 9.78858 11.6438 7.5C11.6438 5.21142 9.78858 3.35616 7.5 3.35616ZM2 7.5C2 4.46243 4.46243 2 7.5 2C10.5376 2 13 4.46243 13 7.5C13 10.5376 10.5376 13 7.5 13C4.46243 13 2 10.5376 2 7.5Z"
                            fill="#1363DF" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M10.5143 10.5439C10.773 10.2875 11.1923 10.2875 11.451 10.5439L13.806 12.8786C14.0647 13.135 14.0647 13.5508 13.806 13.8072C13.5473 14.0636 13.128 14.0636 12.8693 13.8072L10.5143 11.4725C10.2556 11.2161 10.2556 10.8003 10.5143 10.5439Z"
                            fill="#1363DF" />
                    </svg>
                </button>
            </div>

        </div>
    </header>

    <div class="scraii-workflow-body px-3">
        <div class="tasks-page">

            <!-- Tabs -->
            <nav class="tasks-tabs" aria-label="Task filters">
                <button class="tasks-tab" [class.tasks-tab--active]="activeTab === 'upcoming'"
                    (click)="setTab('upcoming')">
                    Upcoming
                </button>

                <button class="tasks-tab" [class.tasks-tab--active]="activeTab === 'assignedToMe'"
                    (click)="setTab('assignedToMe')">
                    Assigned to me
                </button>

                <button class="tasks-tab" [class.tasks-tab--active]="activeTab === 'assignedByMe'"
                    (click)="setTab('assignedByMe')">
                    Assigned by me
                </button>
            </nav>

            <!-- Task groups (filtered) -->
            <div class="tasks-list">
                <ng-container *ngFor="let group of filteredTaskGroups">
                    <div class="tasks-date-label">
                        {{ group.dateLabel }}
                    </div>

                    <article class="task-card" *ngFor="let task of group.tasks" (click)="openModel(task)">
                        <div class="task-card-main px-3 pt-2">
                            <div class="task-card-title-row">
                                <div class="task-card-title-block">
                                    <h3 class="task-name">{{ task.name }}</h3>
                                    <div class="task-type-row">
                                        <span class="task-type-icon" [ngClass]="task.iconColorClass"></span>
                                        <span class="task-type-text">{{ task.type }}</span>
                                    </div>
                                </div>

                                <div class="task-card-right-icons">
                                    <button class="icon-btn small" aria-label="More">
                                        ☰
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="task-card-footer">
                            <span class="task-time-row ps-3">
                                {{ task.startTime }} – {{ task.endTime }}
                            </span>
                            <span class="task-status-pill" [ngClass]="task.statusClass">
                                {{ task.status }}
                            </span>
                        </div>
                    </article>
                </ng-container>
            </div>
        </div>
    </div>
</aside>